import { h } from 'preact';
import { useStore } from 'effector-react';
import { sendEvent } from 'model/helpers/events.model';
import { lastScreen$, screenHistoryPush, ScreenName } from 'model/helpers/screens-history';

import { useLocalization } from 'model/localization.model';
import { ErrorLayout } from 'features/verify/ui/error-layout';
import { useEffect } from 'preact/hooks';

export const Unhandled = () => {
	const t = useLocalization();
	const lastScreen = useStore(lastScreen$);

	useEffect(() => {
		setTimeout(() => {
			sendEvent({
				event: 'unhandled_error_screen_shown',
				event_attributes: {
					type: 'desktop',
					last_screen: lastScreen,
				},
			});
		}, 20);
		screenHistoryPush(ScreenName.error_mobile);
	}, []);

	return (
		<ErrorLayout
			title={t('flow.err.title')}
			description={
				<span
					dangerouslySetInnerHTML={{
						__html: t('flow.err.subtitle', {
							'flow.err.subtitle.sub': `<a href="${t('flow.err.subtitle.url')}">${t('flow.err.subtitle.sub')}</a>`,
						}),
					}}
				/>
			}
		/>
	);
};
